module.exports = __webpack_public_path__ + "img/dark-mode.ad88624b.svg";